import { ONE_TIME, PER_SEMESTER, PER_YEAR } from "@/lib/constants"
import type { FEE_ITEM } from "@/types/form-types"

//preview-fee related hooks
export function useGetPreviewFee() {
	const useGetNonCourseFee = (
		feeComponents: FEE_ITEM[],
		nonCourseFeeComponents: string[],
	) => {
		return feeComponents.filter(feeComponent =>
			nonCourseFeeComponents.includes(feeComponent.component_id),
		)
	}

	const useGetCourseFee = (
		feeComponents: FEE_ITEM[],
		courseFeeComponents: string[],
	) => {
		return feeComponents.filter(feeComponent =>
			courseFeeComponents.includes(feeComponent.component_id),
		)
	}

	const useGetFeeGridBasedOnPaymentPlan = (
		fee: FEE_ITEM[],
		courseFeeComponents: string[],
		selectedNonCourseFeeComponents: string[],
		selectedPaymentPlanComponentId: string,
	): { data: FEE_ITEM[] } => {
		const selectedPaymentPlanComponent = fee.find(
			f => f.component_id === selectedPaymentPlanComponentId,
		)

		// let derivedFeeGrid = []

		const semisterFeePlan = fee.filter(f => {
			return (
				(f.frequency === PER_SEMESTER &&
					f.is_course_component &&
					courseFeeComponents.includes(f.component_id)) ||
				(!f.is_course_component &&
					!selectedNonCourseFeeComponents.includes(f.component_id))
			)
		})

		const annualFeePlan = fee.filter(f => {
			return (
				(f.frequency === PER_SEMESTER &&
					f.is_course_component &&
					courseFeeComponents.includes(f.component_id)) ||
				(!f.is_course_component &&
					(f.frequency === ONE_TIME || f.frequency === PER_YEAR) &&
					!selectedNonCourseFeeComponents.includes(f.component_id)) ||
				(!f.is_course_component && f.frequency === PER_SEMESTER)
			)
		})

		const oneTimeFeePlan = fee.filter(f => {
			return (
				(f.frequency === ONE_TIME &&
					f.is_course_component &&
					courseFeeComponents.includes(f.component_id)) ||
				(!f.is_course_component &&
					f.frequency === ONE_TIME &&
					!selectedNonCourseFeeComponents.includes(f.component_id)) ||
				(!f.is_course_component &&
					(f.frequency == PER_SEMESTER || f.frequency === PER_YEAR))
			)
		})

		if (!selectedPaymentPlanComponent) return { data: [] }

		const selectedPaymentPlan = selectedPaymentPlanComponent.frequency

		if (selectedPaymentPlan === PER_SEMESTER)
			return { data: semisterFeePlan }
		else if (selectedPaymentPlan === PER_YEAR)
			return { data: annualFeePlan }
		else if (selectedPaymentPlan === ONE_TIME)
			return { data: oneTimeFeePlan }
		else return { data: [] }

		// derivedFeeGrid = [
		// 	...semisterFeePlan,
		// 	...annualFeePlan,
		// 	...oneTimeFeePlan,
		// ]

		// return { data: derivedFeeGrid }
	}

	return {
		useGetNonCourseFee,
		useGetCourseFee,
		useGetFeeGridBasedOnPaymentPlan,
	}
}
